import api from '../../../api/client';
// components/Sales.js
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { formatKES } from "../../../utils/currency";
import DataTable from "react-data-table-component";
import SalesAnalytics from "./SalesAnalytics";

const Sales = ({ dateRange, fetchData }) => {
  const [salesData, setSalesData] = useState([]);

  useEffect(() => {
    fetchData("sales", setSalesData);
  }, [dateRange, fetchData]);
if (!salesData || salesData?.length === 0) {
    return <div className="text-center py-4">No sales data available</div>;
  }

  return (
    <div className="mt-4">
      <SalesAnalytics analytics={salesData} />
    </div>
  );
};

export default Sales;
